export default __webpack_public_path__ + "static/media/menu_nose.4fc3ea05.png";